import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, PlayIcon, PhoneIcon } from 'lucide-react';
import { CTARow } from './CTARow';
export function HeroSection() {
  return <section className="pt-32 pb-16 md:pt-40 md:pb-24 bg-white overflow-hidden" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-69">
          {/* Left Column: Video Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1 flex justify-center" data-id="element-70">
            <div className="relative aspect-[9/16] w-full max-w-sm bg-gray-900 rounded-2xl shadow-2xl overflow-hidden" data-id="element-71">
              <video src="https://cdn.magicpatterns.com/uploads/6jn341DPc3vTmX8SfAAecQ/Jessica_ Your AI Receptionist_1080p_caption (1).mp4" controls playsInline className="w-full h-full object-contain bg-black" data-id="element-72">
                Your browser does not support the video tag.
              </video>
            </div>
          </motion.div>

          {/* Right Column: Content */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2" data-id="element-73">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-74">
              Never Miss Another{' '}
              <span className="text-viridia-600" data-id="element-75">High-Value Call</span> Again.
            </h1>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-76">
              Jessica, your 24/7 AI Receptionist, answers every call, qualifies
              leads, and books appointments so you stop losing money to
              voicemail.
            </p>

            <ul className="space-y-4 mb-6" data-id="element-77">
              {['Answers every call 24/7, even when you are busy or closed.', 'Qualifies callers and books them straight into your calendar.', 'Costs a fraction of a full-time receptionist.'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-78">
                  <CheckCircleIcon className="w-6 h-6 text-viridia-500 flex-shrink-0 mt-0.5" data-id="element-79" />
                  <span className="text-gray-700 font-medium" data-id="element-80">{item}</span>
                </li>)}
            </ul>

            <p className="text-gray-500 italic mb-6 leading-relaxed" data-id="element-81">
              When you call, Jessica will show you exactly how she handles calls
              for your business, then schedule a free Strategy Call with Kevin.
            </p>

            <div className="mb-6" data-id="element-82">
              <p className="flex items-center gap-2 text-lg font-bold text-gray-900 mb-3" data-id="element-83">
                <PhoneIcon className="w-5 h-5 text-viridia-600" data-id="element-84" />
                Call Jessica now:{' '}
                <a href="tel:6233000708" className="text-viridia-600 hover:underline" data-id="element-85">
                  623-300-0708
                </a>
              </p>
              <CTARow data-id="element-86" />
              <p className="mt-3 text-sm text-gray-500" data-id="element-87">
                Month-to-month. No long-term contracts.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}